import { Table } from "antd";
import { useCallback } from "react";
import { truncateFloat } from "../../../../helpers/generalHelper";

export const useColumnsAnalitySize = ({ filterValue } = {}) => {

    const getTotalTime = useCallback((project) => {
        const { calculatedHours, development, testing, planning } = project;
        const { total: budgetDevelopment, testing: budgetTesting } = calculatedHours.development;
        const { planning: budgetPlanning } = calculatedHours;

        return { budgetPlanning, budgetDevelopment, budgetTesting: (budgetTesting || 0), spentPlanning: planning, spentDevelopment: development, spentTesting: testing };

    }, []);

    const getExpandedTableData = useCallback((record) => {
        const { spentPlanning, spentDevelopment, spentTesting } = getTotalTime(record);
        const { development: { total: totalDevelopmentCalcuated, testing: testingCalculated = 0 }, planning: planningCalculated } = record.calculatedHours;
        const globalDevelopmentCalcuated = totalDevelopmentCalcuated + (testingCalculated || 0);
        const totalBudgetCalculated = totalDevelopmentCalcuated + (testingCalculated || 0) + planningCalculated;


        const spentTotalDevelopment = spentDevelopment + (spentTesting || 0)
        const totalSpent = spentPlanning + spentDevelopment + (spentTesting || 0);
        const isIncorrectDevelopment = spentTotalDevelopment === 0 || totalSpent === 0;
        const isIncorrectPlanning = spentPlanning === 0 || totalSpent === 0;


        return [
            {
                key: 0,
                description: "Horas Desarrollo",
                budget: truncateFloat(globalDevelopmentCalcuated),
                budgetpercentage: truncateFloat((globalDevelopmentCalcuated * 100) / totalBudgetCalculated),
                work: truncateFloat(spentTotalDevelopment),
                workpercentage: isIncorrectDevelopment ? 0 : truncateFloat((spentTotalDevelopment * 100) / totalSpent),
            },
            {
                key: 1,
                description: "Horas Planeación",
                budget: truncateFloat(planningCalculated),
                budgetpercentage: truncateFloat((planningCalculated * 100) / totalBudgetCalculated),
                work: truncateFloat(spentPlanning),
                workpercentage: isIncorrectPlanning ? 0 : truncateFloat((spentPlanning * 100) / totalSpent),

            },
        ];

    }, [getTotalTime])



    const expandedTable = useCallback((record) => {
        const subDate = getExpandedTableData(record);
        return (
            < Table
                columns={
                    [
                        {
                            title: "Descripciòn",
                            dataIndex: "description",
                            key: "description",
                        },
                        {
                            title: "Presupuesto",
                            dataIndex: "budget",
                            key: "budget",
                        },
                        {
                            title: "%",
                            dataIndex: "budgetpercentage",
                            key: "budgetpercentage",
                            render: (text) => <span>{text}%</span>,
                        },
                        {
                            title: "Trabajo",
                            dataIndex: "work",
                            key: "work",
                        },
                        {
                            title: "%",
                            dataIndex: "workpercentage",
                            key: "workpercentage",
                            className: "colorColumnSize",
                            render: (text) => <span>{text}%</span>,
                        },
                    ]}
                dataSource={subDate}
                summary={(pageData = []) => {
                    const { budget: developmentBudget, work: developmentWork } = pageData[0];
                    const { budget: planningBudget, work: planningWork } = pageData[1];
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                            <Table.Summary.Cell index={1}>
                                <span>{truncateFloat(developmentBudget + planningBudget)}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2}>
                                <span>100%</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={3}>
                                <span>{truncateFloat(developmentWork + planningWork)}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={4}>
                                <span>100%</span>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    );
                }}
                pagination={
                    {
                        position: ["none", "none"],
                    }
                }
            />
        )
    }, [getExpandedTableData])

    const getProjectTotalNumbers = useCallback((projects) => {

        const { budgetPlanning, budgetDevelopment, budgetTesting, spentPlanning, spentDevelopment, spentTesting } = projects.reduce((total, project) => {
            const { budgetPlanning, budgetDevelopment, budgetTesting, spentPlanning, spentDevelopment, spentTesting } = getTotalTime(project)

            total.budgetPlanning += budgetPlanning
            total.budgetDevelopment += budgetDevelopment
            total.budgetTesting += budgetTesting

            total.spentPlanning += spentPlanning
            total.spentDevelopment += spentDevelopment
            total.spentTesting += spentTesting

            return total;
        }, { budgetPlanning: 0, budgetDevelopment: 0, budgetTesting: 0, spentPlanning: 0, spentDevelopment: 0, spentTesting: 0 });

        const totalBudgetDevelopment = (budgetDevelopment + budgetTesting)
        const totalDevelopment = (spentDevelopment + spentTesting);

        const budgetTotal = budgetPlanning + budgetDevelopment + budgetTesting;
        const total = spentPlanning + spentDevelopment + spentTesting

        const budgetDevelopmentPercentage = (totalBudgetDevelopment * 100) / budgetTotal;
        const budgetPlanningPercentage = (budgetPlanning * 100) / budgetTotal;
        const developmentPercentage = (totalDevelopment * 100) / total;
        const planningPercentage = (spentPlanning * 100) / total;

        return {
            totalBudgetDevelopment, budgetDevelopmentPercentage, totalDevelopment, developmentPercentage, budgetPlanning, budgetPlanningPercentage, spentPlanning, planningPercentage, total, budgetTotal
        }
    }, [getTotalTime])


    const getExpandedColumns = useCallback((projects) => {
        if (projects.length === 0) return []
        const filters = projects.reduce((filters, project) => {
            if (!filters.sizes[project.size]) {
                filters.sizes[project.size] = { text: project.size, value: project.size, };
            }
            if (!filters.statuses[project.status]) {
                filters.statuses[project.status] = { text: project.status, value: project.status, };
            }

            return filters
        }, { sizes: {}, statuses: {} });

        return [
            {
                title: "Nombre",
                dataIndex: "name",
                key: "name",
                width: 550
            },
            {
                title: "Tamaño",
                dataIndex: "size",
                key: "size",
                filters: Object.values(filters.sizes),
                onFilter: (value, record) => {
                    return record.size === value;
                },
                filteredValue: filterValue.size
            },
            {
                title: "Estatus",
                dataIndex: "status",
                key: "status",
                filters: Object.values(filters.statuses),
                filteredValue: filterValue.status,
                onFilter: (value, record) => {
                    return record.status === value;
                },
            },

        ]
    }, [filterValue])


    const columnsSumTotalProyects = [
        {
            title: "Totales",
            dataIndex: "name",
            key: "name",
            width: 250,

        },
        {
            title: "Presupuesto",
            dataIndex: "sumTotalBudget",
            key: "sumTotalBudget",
            width: 250,
        },
        {
            title: "%",
            dataIndex: "sumTotalPercentBudget",
            key: "sumTotalPercentBudget",
            width: 250,
            render: (text) => <span>{isNaN(text) ? 0 : truncateFloat(text)}%</span>,
        },
        {
            title: "Trabajado",
            dataIndex: "sumTotalWork",
            key: "sumTotalWork",
            width: 250,
        },
        {
            title: "%",
            dataIndex: "sumTotalPercentWork",
            key: "sumTotalPercentWork",

            render: (text) => <span>{isNaN(text) ? 0 : truncateFloat(text)}%</span>,
        },
    ];

    const sumemeryTotalProyects = (pageData = []) => {
        let totals = {
            totalBudget: 0,
            totalWork: 0,
        };
        pageData.forEach((page) => {
            totals.totalBudget += page.sumTotalBudget;
            totals.totalWork += page.sumTotalWork;
        });
        return (
            <Table.Summary.Row>
                <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                <Table.Summary.Cell index={1}>
                    <span>{totals.totalBudget.toFixed(2)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2}>
                    <span>100%</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                    <span>{totals.totalWork.toFixed(2)}</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4}>
                    <span>100%</span>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        );
    };

    const propsColumnsSumTotalProyects = {
        summary: sumemeryTotalProyects,

    };

    return {
        expandedTable,
        getExpandedColumns,
        getExpandedTableData,
        sumemeryTotalProyects,
        getProjectTotalNumbers,
        columnsSumTotalProyects,
        propsColumnsSumTotalProyects,
    };
};
